import { render, staticRenderFns } from "./ConfigureLegoLevel.vue?vue&type=template&id=fc283870&scoped=true&"
import script from "./ConfigureLegoLevel.vue?vue&type=script&lang=ts&"
export * from "./ConfigureLegoLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc283870",
  null
  
)

export default component.exports